import { Typography } from '../Typography';
import { cx } from '../theme';
import { TypographyVariant } from '../theme/typography';

import { ChipStyled } from './Chip.styles';
import { ChipProps, ChipSize } from './types';

/**
 * Chip component.
 */

const typographyVariant: Record<ChipSize, TypographyVariant> = {
  m: 'bodySemiBold',
  s: 'captionSemiBold',
  xs: 'small',
};

export const Chip = ({
  variant,
  text,
  uppercase = false,
  size = 'm',
  className,
}: ChipProps) => (
  <ChipStyled
    className={cx('chip', className)}
    size={size}
    uppercase={uppercase}
    variant={variant}
  >
    <Typography className="chip-text" variant={typographyVariant[size]}>
      {text}
    </Typography>
  </ChipStyled>
);
